<template>
	<view class="page">
		<!--头部-->
		<Header :tabIndex="tabIndex_f" :key="datekey" />
		<!--广告位-->
		<view class="advertise"></view>
		<!--切换-->
		<view class="tab">
			<view class="subject">
				<view class="name">科目</view>
				<view class="subjectListBox">
					<view class="subjectList" v-for="({name,id},index) in subjectList" :key="index"
						:class="index==subjectIndex ? 'active': ''" @click="handleSubject(id,index)">{{name}}</view>
				</view>
			</view>
			<view class="version" v-show="showVersion">
				<view class="name">版本</view>
				<view class="versionListBox">
					<view class="versionList" v-for="(item,index) in versionList" :key="index"
						:class="index==versionIndex ? 'active': ''" @click="handleVersion(item,index)">{{item}}</view>
				</view>
			</view>
			<view class="grade" ref="grade">
				<view class="name">年级</view>
				<view class="gradeListBox">
					<view class="gradeList" v-for="(item,index) in gradeList" :key="index"
						:class="index==gradeIndex ? 'active': ''" @click="handleGrade(item,index)">{{item}}</view>
				</view>
			</view>
			<view class="ceci" v-show="showCeci">
				<view class="name">册次</view>
				<view class="ceciListBox">
					<view class="ceciList" v-for="(item,index) in ceciList" :key="index"
						:class="index==ceciIndex ? 'active': ''" @click="handleCeci(item,index)">{{item}}</view>
				</view>
			</view>
		</view>
		<!--教材列表-->
		<view class="teachList" v-if="bookList.length">
			<view class="book"
				v-for="({icon_url,book_name,grade,term,book_id,isFree,xmMark,subject_id,isAdd,version_type},index) in bookList"
				:key="index">
				<view class="free" v-if="xmMark == true">限免</view>
				<view class="buyMark"
					v-if="subject_id == '11' && isFree == false || subject_id == '12' && isFree == false">已购</view>
				<image :src="icon_url" alt="" class="cover" @click="handleClick(book_id,book_name,grade,term)" />
				<!-- <view class="bookName">{{book_name+ grade+term}}</view> -->
				<!--体育与健康学科3本教材特殊处理-->
				<view class="bookName"
					v-if="book_id == 1272001103121 || book_id == 1272001303141 || book_id == 1272001503141">
					<view class="row1">{{book_name}}</view>
					<view class="row2">{{grade}}</view>
					<view class="row3">{{term}}</view>
				</view>
				<view class="bookName" v-else-if="version_type == '高中'">
					<view class="row1" style="text-align: center;">{{book_name}}</view>
				</view>
				<view class="bookName" v-else>
					<view class="row1">{{book_name}}</view>
					<view class="row2">{{grade+term}}</view>
				</view>
				<view v-if="subject_id == '11' || subject_id == '12'">
					<view class="unpurchased" v-show="isFree == true">
						<view class="cartBox" @click="handleAddCart(book_id)">
							<image src="@/static/images/cart.png" alt="" class="cart" />
						</view>
						<view class="goToBuy" @click="handleClickToBuy(book_id)">立即购买</view>
					</view>
					<view class="purchased" v-show="isFree == false" @click="handleStudy(book_id,book_name,grade,term)">
						开始学习
					</view>
				</view>
				<view class="study" @click="handleStudyClick(book_id,book_name,grade,term,isAdd)" v-else>
					{{isAdd == false ? '加入"我的学习"' : '开始学习'}}
				</view>
			</view>
		</view>
		<view v-else class="empty">
			暂无教材
		</view>
		<!--底部-->
		<Footer />
		<!--侧边栏-->
		<Sidebar />

		<!--阴影框-->
		<view class="shadow" v-show="isLogin" @click.self="handleClickLogin()">
			<Login @handleClickLogin_son="handleClickLogin" @judgeBuyFn_son="judgeBuyFn" />
		</view>

	</view>
</template>

<script>
	import Header from '@/components/Header.vue'; //头部
	import Footer from '@/components/Footer.vue'; //底部
	import Sidebar from '@/components/Sidebar.vue'; //侧边栏
	import Login from '@/components/Login.vue'; //登录框
	import md5 from 'js-md5';
	import {
		safeFn
	} from '@/util/common.js';

	export default {
		data() {
			return {
				subjectList: [], //科目列表
				subjectIndex: 0, //科目索引
				subjectId: 'all', //学科id
				// gradeList: ['全部', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '七年级', '八年级', '九年级', '高中'], //年级列表
				gradeList: ['全部', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '七年级', '八年级', '九年级'], //年级列表
				gradeIndex: 0, //年级索引
				gradeName: '全部', //年级
				ceciList: ['全部', '上册', '下册', '全一册'], //册次列表
				ceciIndex: 0, //册次索引
				ceciName: '全部', //册次
				bookList: [], //教材列表
				myCourseList: [], //我添加的课程/教材
				tempBookList: null, //教材列表-中间变量
				showVersion: false, //控制显示版本
				versionList: [], //版本列表
				versionIndex: 0, //版本索引
				tempVersionList: null, //版本列表中间变量
				versionName: '', //版本名称
				tabIndex_f: 0, //父组件传的值
				isToken: this.$store.state.token ? true : false,
				isLogin: false,
				userId: this.$store.state.userId, //用户id
				buysList: [], //已购教材
				datekey: Date.now(),
				freeList: [], //限免教材列表
				md5Str: '', //md5串
				showCeci: true, //控制显示册次列
			}
		},
		onLoad() {
			// console.log(this.isToken,this.$store.state.token)
			if (this.isToken) { //登录后
				safeFn(this.userId); //安全验证

				this.myCourse(); //我添加的课程/教材
			} else { //未登录
				this.getFreeTextBook(); //获取免费教材
			}

			sessionStorage.setItem('showQrCode', '0');
		},
		methods: {
			//科目切换
			handleSubject(id, index) {
				this.subjectId = id;
				this.subjectIndex = index;

				//英语&音乐
				if (this.subjectId == '12' || this.subjectId == '62') {
					this.showVersion = true;
					this.versionIndex = 0;
					let result = this.tempVersionList.find(item => item.subject_id == this.subjectId);
					let data = result.versions;
					let arr = [];
					data.forEach((item) => {
						arr.push(item.version_type);
					})
					this.versionList = arr;
					this.versionName = this.versionList[0];
				} else {
					this.showVersion = false;
				}

				this.textBookSelectFn(); //教材筛选

			},
			//教材筛选
			textBookSelectFn() {
				let data = this.tempBookList;
				let _this = this;
				let result = data.filter(function(item) {
					if (_this.subjectId == 'all' && _this.gradeName == '全部' && _this.ceciName == '全部') {
						return data;
					} else if (_this.subjectId == 'all' && _this.gradeName == '全部' && _this.ceciName != '全部') {
						return item.term == _this.ceciName;
					} else if (_this.subjectId == 'all' && _this.gradeName != '全部' && _this.ceciName == '全部') {
						return item.grade == _this.gradeName;
					} else if (_this.subjectId == 'all' && _this.gradeName != '全部' && _this.ceciName != '全部') {
						return item.grade == _this.gradeName && item.term == _this.ceciName;
					} else if (_this.subjectId != 'all' && _this.gradeName == '全部' && _this.ceciName == '全部') {
						if (_this.subjectId == '12' || _this.subjectId == '62') { //英语&音乐
							return item.subject_id == _this.subjectId && item.version_type == _this.versionName;
						} else {
							return item.subject_id == _this.subjectId;
						}
					} else if (_this.subjectId != 'all' && _this.gradeName == '全部' && _this.ceciName != '全部') {
						if (_this.subjectId == '12' || _this.subjectId == '62') { //英语&音乐
							return item.subject_id == _this.subjectId && item.term == _this.ceciName && item
								.version_type == _this.versionName;
						} else {
							return item.subject_id == _this.subjectId && item.term == _this.ceciName;
						}
					} else if (_this.subjectId != 'all' && _this.gradeName != '全部' && _this.ceciName == '全部') {
						if (_this.subjectId == '12' || _this.subjectId == '62') { //英语&音乐
							return item.subject_id == _this.subjectId && item.grade == _this.gradeName && item
								.version_type == _this.versionName;
						} else if (_this.subjectId == '72') { //体育与健康
							return item.subject_id == _this.subjectId && (item.grade).includes(_this.gradeName);
						} else {
							return item.subject_id == _this.subjectId && item.grade == _this.gradeName;
						}
					} else if (_this.subjectId != 'all' && _this.gradeName != '全部' && _this.ceciName != '全部') {

						if (_this.subjectId == '12' || _this.subjectId == '62') { //英语&音乐
							return item.subject_id == _this.subjectId && item.grade == _this.gradeName && item
								.term ==
								_this.ceciName && item.version_type == _this.versionName;
						} else if (_this.subjectId == '72') { //体育与健康
							return item.subject_id == _this.subjectId && (item.grade).includes(_this.gradeName) &&
								item.term == _this.ceciName;
						} else {
							return item.subject_id == _this.subjectId && item.grade == _this.gradeName && item
								.term ==
								_this.ceciName;
						}
					}
				})
				this.bookList = result;
			},
			//版本切换
			handleVersion(item, index) {
				this.versionIndex = index;
				this.versionName = item;

				this.textBookSelectFn(); //教材筛选

			},
			//年级切换
			handleGrade(item, index) {
				this.gradeName = item;
				this.gradeIndex = index;
				
				// console.log(item,index,'=============');
				if(item == '高中') {
					this.gradeName = '高中一年级';
					this.showCeci = false;
					this.$refs.grade.$el.style.borderBottom = 'none';
				} else {
					this.showCeci = true;
					this.$refs.grade.$el.style.borderBottom = '1px solid #ECECEC';
				}
				
				this.textBookSelectFn(); //教材筛选
			},
			//册次切换
			handleCeci(item, index) {
				this.ceciName = item;
				this.ceciIndex = index;
				this.textBookSelectFn(); //教材筛选
			},
			//教材列表
			teachListFn() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					// url = this.baseApi + '/static/textbook/bookList_pep_click_subject_web_1_0_0.json';
					url = this.baseTeach + '/static/textbook/bookList_pep_click_subject_web_1_0_0.json';
				} else {
					if (location.hostname.indexOf('dianducs') >= 0) {
						// url = this.baseURL + '/static/textbook/bookList_pep_click_subject_web_1_0_0.json';
						url = this.baseTeachUrl + '/static/textbook/bookList_pep_click_subject_web_1_0_0.json';

						// url = this.baseTeachUrl + '/static/textbook/bookList_pep_click_subject_5_0.json'; //app
						// url = this.baseTeachUrl + '/static/textbook/chapter/' + '1211001201171' + '_sentence.json'; //测评
					} else {
						url = 'https://diandu.mypep.cn/static/textbook/bookList_pep_click_subject_web_1_0_0.json';
					}
				}
				uni.request({
					url: url,
					method: 'get',
					data: {},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel,
					},
					success: res => {
						if (res.statusCode == '200') {
							// console.log(res, '教材列表数据');
							let data = res.data.booklist;
							this.tempVersionList = data;

							// console.log(data)

							//学科列表
							data.forEach((item) => {
								this.subjectList.push({
									id: item.subject_id,
									name: item.subject_name
								});
							})
							this.subjectList.unshift({
								id: 'all',
								name: '全部'
							})
							// console.log(this.subjectList)

							//教材列表
							let arr = [];
							for (let i = 0; i < data.length; i++) {
								let item = data[i].versions;
								for (let j = 0; j < item.length; j++) {
									arr.push(item[j].textbooks);
								}
							}
							this.bookList = arr.flat();


							//免费教材
							let str = JSON.stringify(this.freeList);
							for (var i = 0; i < this.bookList.length; i++) {
								for (var k = 0; k < this.freeList.length; k++) {
									if (this.bookList[i].book_id == this.freeList[k].book_id && this.md5Str ===
										md5(str + 'rjdd_jszx')) {
										this.bookList[i].xmMark = true;
									}
								}
							}


							//已购教材
							for (var i = 0; i < this.bookList.length; i++) {
								this.bookList[i].isFree = true;
								this.bookList[i].isAdd = false; //判断是否加入我的学习
							}
							if (this.isToken == true) {
								this.judgeBuyFn(); //获取用户已购买的书籍
							}

							this.tempBookList = this.bookList;

							// console.log(this.bookList, '...')

							//判断是否加入我的学习
							for (var i = 0; i < this.bookList.length; i++) {
								for (var l = 0; l < this.myCourseList.length; l++) {
									if (this.bookList[i].book_id == this.myCourseList[l].book_id) {
										this.bookList[i].isAdd = true;
									}
								}
							}

							// console.log(this.bookList, '...')
						}
					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//获取免费教材
			getFreeTextBook() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/user/free_textbook.anys';
				} else {
					url = this.baseURL + '/user/free_textbook.anys';
				}
				uni.request({
					url: url,
					method: 'post',
					data: {},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '免费教材数据');
						if (res.statusCode == '200') {
							let data = res.data.freeList;
							this.freeList = data;
							this.md5Str = res.data.md5;
							this.teachListFn(); //教材列表
						}

					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//跳转至教材页
			handleClick(book_id, book_name, grade, term) {
				let baseWidth; //底图宽度
				let baseHeight; //底图高度

				let tbName = book_name + grade + term;
				this.$store.commit('setTbName', tbName);

				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;

				uni.request({
					url: this.baseStatic + "/pub_cloud/10/" + book_id + "/TBInfo.json",
					method: 'get',
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '获取底图宽高数据');
						if (res.statusCode == '200') {
							baseWidth = res.data.page_width;
							baseHeight = res.data.page_height;
						} else if (res.statusCode == '404') {
							baseWidth = 766;
							baseHeight = 1080;
						}

						this.$store.commit('setTbId', book_id); //存教材id
						this.$store.commit('setThirdKey', 'pep_click'); //存第三方授权key
						this.$store.commit('setBaseWidth', baseWidth); //存底图宽度
						this.$store.commit('setBaseHeight', baseHeight); //存底图高度

						if (dev_pro == 'development') {
							// url = location.href + 'pages/index/index'; //本地环境
							url = location.origin + '#/pages/index/index'; //本地环境
						} else {
							if (location.hostname.indexOf('dianducs') >= 0) {
								url = this.baseURL + '/rjdd/#/pages/index/index'; //测试环境
							} else {
								url = this.baseURL + '/dist/#/pages/index/index'; //正式环境
							}
						}

						window.open(url, '_blank');

					},
					fail: err => {
						console.log(err);
					}
				})

			},
			//开始学习
			handleStudy(book_id, book_name, grade, term) {
				this.handleClick(book_id, book_name, grade, term); //跳转至教材页
			},
			//处理关于学习的点击
			handleStudyClick(book_id, book_name, grade, term, isAdd) {
				// console.log(isAdd,'99')
				if (isAdd == false) { //未加入我的学习
					this.handleToMyStudy(book_id); //加入我的学习
				} else {
					this.handleClick(book_id, book_name, grade, term); //跳转至教材页
				}
			},
			//加入购物车
			handleAddCart(book_id) {
				if (this.isToken) {
					this.$store.commit('setTbId', book_id); //存教材id

					uni.navigateTo({
						// url: '/pages/details/index?bookId=' + book_id
						url: '/pages/details/index'
					});
				} else {
					this.isLogin = true;
				}
			},
			//立即购买
			handleClickToBuy(book_id) {
				if (this.isToken) {
					this.$store.commit('setTbId', book_id); //存教材id

					uni.navigateTo({
						// url: '/pages/details/index?bookId=' + book_id
						url: '/pages/details/index'
					});
				} else {
					this.isLogin = true;
				}
			},
			//加入我的学习
			handleToMyStudy(book_id) {
				if (this.isToken) {
					this.addToMyStudy(book_id); //加入我的学习接口
				} else {
					this.isLogin = true;
				}
			},
			//加入我的学习接口
			addToMyStudy(book_id) {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/book/ak/pep_click/user/' + this.userId + '/add_my_book.json';
				} else {
					url = this.baseURL + '/book/ak/pep_click/user/' + this.userId + '/add_my_book.json';
				}
				uni.request({
					url: url,
					method: 'post',
					data: {
						access_token: this.$store.state.token,
						bookids: book_id
					},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '加入我的学习');
						if (res.statusCode == '200') {
							if (res.data.errcode == '110') {
								this.showTips('添加成功'); //tips提示
								uni.navigateTo({
									// url: '/pages/myStudy/index?userId=' + this.userId
									url: '/pages/myStudy/index'
								});
							}
						}
					},
					fail: err => {
						console.log(err);
					}
				})

			},
			//tips提示
			showTips(title, icon) {
				uni.showToast({
					title: title,
					icon: icon,
					duration: 2000
				});
			},
			//我添加的课程/教材
			myCourse() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/book/ak/pep_click/user/' + this.userId + '/my_book.json';
				} else {
					url = this.baseURL + '/book/ak/pep_click/user/' + this.userId + '/my_book.json';
				}
				uni.request({
					url: url,
					method: 'post',
					data: {
						access_token: this.$store.state.token
					},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '我添加的课程/教材');
						if (res.statusCode == '200') {
							if (res.data.errcode == '110') {
								this.myCourseList = res.data.result.textbooks;
								this.getFreeTextBook(); //获取免费教材
								// console.log(this.myCourseList, '我添加的课程/教材');
							}
						}
					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//登录框切换
			handleClickLogin() {
				this.isLogin = false;
				this.datekey = Date.now();
			},
			//获取用户已购买的书籍
			judgeBuyFn() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/user/ak/pep_click/user/' + this.userId + '/my_orderbooks.json';
				} else {
					url = this.baseURL + '/user/ak/pep_click/user/' + this.userId + '/my_orderbooks.json';
				}
				uni.request({
					url: url,
					method: 'post',
					data: {
						access_token: this.$store.state.token
					},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '获取用户已购买的书籍');
						if (res.statusCode == '200') {
							this.buysList = res.data.books;
							for (var i = 0; i < this.bookList.length; i++) {
								for (var j = 0; j < this.buysList.length; j++) {
									let item = this.buysList[j];
									if (this.bookList[i].book_id === item.bookid &&
										item.bookkey === md5(item.bookid +
											item.powertime + 'rjdd_jszx')) {
										this.bookList[i].isFree = false;
									}
								}
							}

							this.$forceUpdate();
						}

					},
					fail: err => {
						console.log(err);
					}
				})
			},

		},
		components: {
			Header,
			Footer,
			Sidebar,
			Login
		}
	}
</script>

<style lang="scss" scoped scoped>
	@import "@/style/home/index.scss"; //引入样式文件
</style>